import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from 'services/http.service';
import { ServiceBase } from 'services/servicebase';
import { ToastService } from '@core/components/toasts/toasts.service';
import { ActionPlanTypeModel } from 'services/models/corporate/action-plan/action-plan-type.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionPlanTypeService extends ServiceBase<ActionPlanTypeModel> {
  constructor(
    http: HttpService,
    public _toasterService: ToastService
  ) {
    super('actionplan/type', http, environment.apiUrl);
  }

  createEntity(input: any): ActionPlanTypeModel {
    return ActionPlanTypeModel.create(input);
  }

  createOrUpdate(data: any): Observable<any> {
    if (data?.id) {
      return this.http.put(`${this.endpoint}/update`, data);
    }

    return this.http.post(`${this.endpoint}/create`, data, null, null, true);
  }
}
